export const CARD_WIDTH = 262;
export const CARDS_VISIBLE = 4;
export const CARDS_SCROLL_BY = 1;
export const GAP = 24;
